import * as Mui from "@mui/material";
import useOperationTranslation from "../../../hooks/useOperationTranslation";
import OperationTypes from "../../../types";
import FormInput from "../../common/FormInput";

interface Props {
  drivers?: OperationTypes.Drivers[];
}

const Drivers = (props: Props) => {
  const t = useOperationTranslation();

  if (props.drivers?.length === 0)
    return (
      <Mui.Box textAlign={"center"}>
        <Mui.Typography variant="h6">
          {t("transferReason.messages.noDrivers")}
        </Mui.Typography>
      </Mui.Box>
    );

  return (
    <>
      {props.drivers?.map((driver: any, index: number) => (
        <Mui.Box key={`drivers-box-${index}`} mb={2}>
          <Mui.Card key={`drivers-card-${index}`}>
            <Mui.CardContent key={`drivers-card-content-${index}`}>
              <Mui.Grid
                container
                key={`drivers-grid-content-${index}`}
                columns={12}
                alignItems="center"
                spacing={2.5}
                rowGap={4}
              >
                <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                  <FormInput
                    name="name"
                    label={t("transferReason.details.tab5.name")}
                    value={driver?.name || ""}
                    type="text"
                    disabled
                    fullWidth
                  />
                </Mui.Grid>
                <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                  <FormInput
                    name="surname"
                    label={t("transferReason.details.tab5.surname")}
                    value={driver?.surname || ""}
                    type="text"
                    disabled
                    fullWidth
                  />
                </Mui.Grid>
                <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                  <FormInput
                    name="address"
                    label={t("transferReason.details.tab5.address")}
                    value={driver?.address || ""}
                    type="text"
                    disabled
                    fullWidth
                  />
                </Mui.Grid>
                <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                  <FormInput
                    name="birthDate"
                    label={t("transferReason.details.tab5.birthDate")}
                    value={driver?.birthDate || ""}
                    type="date"
                    disabled
                    fullWidth
                    inputFormat={"DD/MM/YYYY"}
                  />
                </Mui.Grid>
                <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                  <FormInput
                    name="birthNation"
                    label={t("transferReason.details.tab5.birthNation")}
                    value={driver?.birthNation || ""}
                    type="text"
                    disabled
                    fullWidth
                  />
                </Mui.Grid>
                <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                  <FormInput
                    name="countryResidence"
                    label={t("transferReason.details.tab5.countryResidence")}
                    value={driver?.countryResidence || ""}
                    type="text"
                    disabled
                    fullWidth
                  />
                </Mui.Grid>
                <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                  <FormInput
                    name="residenceAddress"
                    label={t("transferReason.details.tab5.residenceAddress")}
                    value={driver?.residenceAddress || ""}
                    type="text"
                    disabled
                    fullWidth
                  />
                </Mui.Grid>
                <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                  <FormInput
                    name="fiscalCode"
                    label={t("transferReason.details.tab5.fiscalCode")}
                    value={driver?.fiscalCode || ""}
                    type="text"
                    disabled
                    fullWidth
                  />
                </Mui.Grid>
                <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                  <FormInput
                    name="drivingLicenceNumber"
                    label={t(
                      "transferReason.details.tab5.drivingLicenseNumber"
                    )}
                    value={driver?.drivingLicenseNumber || ""}
                    type="text"
                    disabled
                    fullWidth
                  />
                </Mui.Grid>
                <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                  <FormInput
                    name="mobile"
                    label={t("transferReason.details.tab5.mobile")}
                    value={driver?.mobile || ""}
                    type="number"
                    disabled
                    fullWidth
                  />
                </Mui.Grid>
                <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                  <FormInput
                    name="driverStationDescription"
                    label={t("transferReason.details.tab5.driverStationDescription")}
                    value={driver?.driverStationDescription || ""}
                    type="text"
                    disabled
                    fullWidth
                  />
                </Mui.Grid>
              </Mui.Grid>
            </Mui.CardContent>
          </Mui.Card>
        </Mui.Box>
      ))}
    </>
  );
};

export default Drivers;
